export default __webpack_public_path__ + "static/media/White_Cloud_large_8.90dbf294.jpg";